import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Title.module.scss';

class Title extends Component {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const {
      props: { className, title }
    } = this;
    return (
      <div className={className}>
        <h1
          className={styles.Title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Title/Title.js